/** Preserve the capture-phase delegation contract used by the site components. */
export default function delegate(...args) {
	if (args.length === 3) args.unshift([document.documentElement]);
	const [roots, eventNames, selector, callback] = args;
	const nodes = value => typeof value === 'string'
		? Array.from(document.querySelectorAll(value))
		: value.nodeType ? [value] : Array.from(value);
	const elements = nodes(roots);
	const targets = typeof selector === 'string' ? selector : nodes(selector);
	const listener = event => {
		const target = event.target.nodeType === 1 ? event.target : event.target.parentElement;
		const matched = typeof targets === 'string'
			? target?.closest(targets)
			: targets.find(node => node === target || node.contains(target));
		if (matched) {
			event.relatedElements = elements;
			callback.call(matched, event, matched);
		}
	};
	const events = eventNames.split(' ');
	for (const element of elements) {
		for (const event of events) element.addEventListener(event, listener, true);
	}
	// Keep the listener return value so existing removeEventListener callers remain valid.
	return listener;
}
